// Enums TS espelhando o schema Prisma de @app-ponto/db.
// Mantidos como uniao de literais para serializacao/validacao zod direta.
export const RegistroTipo = {
    ENTRADA: 'entrada',
    SAIDA: 'saida',
    INTERVALO_IN: 'intervalo_in',
    INTERVALO_OUT: 'intervalo_out',
    EXTRA: 'extra',
};
export const REGISTRO_TIPOS = [
    'entrada',
    'saida',
    'intervalo_in',
    'intervalo_out',
    'extra',
];
export const RegistroStatus = {
    PENDENTE: 'pendente',
    VALIDADO: 'validado',
    REJEITADO: 'rejeitado',
    AJUSTADO: 'ajustado',
};
export const REGISTRO_STATUSES = [
    'pendente',
    'validado',
    'rejeitado',
    'ajustado',
];
export const Plataforma = {
    ANDROID: 'android',
    IOS: 'ios',
    PWA: 'pwa',
};
export const PLATAFORMAS = ['android', 'ios', 'pwa'];
export const GeofenceTipo = {
    CIRCULO: 'circulo',
    POLIGONO: 'poligono',
};
export const GEOFENCE_TIPOS = ['circulo', 'poligono'];
export const RoleNome = {
    SUPER_ADMIN: 'SUPER_ADMIN',
    ADMIN_EMPRESA: 'ADMIN_EMPRESA',
    GESTOR_SECRETARIA: 'GESTOR_SECRETARIA',
    FUNCIONARIO: 'FUNCIONARIO',
};
export const ROLE_NOMES = [
    'SUPER_ADMIN',
    'ADMIN_EMPRESA',
    'GESTOR_SECRETARIA',
    'FUNCIONARIO',
];
export const Recurso = {
    EMPRESA: 'empresa',
    SECRETARIA: 'secretaria',
    SETOR: 'setor',
    FUNCIONARIO: 'funcionario',
    BIOMETRIA: 'biometria',
    DISPOSITIVO: 'dispositivo',
    ESCALA: 'escala',
    GEOFENCE: 'geofence',
    PONTO: 'ponto',
    RELATORIO: 'relatorio',
    // Recursos extras (fora do cross-product recurso x acao — ver PERMISSIONS_EXTRAS)
    AUDITORIA: 'auditoria',
    NOTIFICACOES: 'notificacoes',
    EMPRESAS: 'empresas',
    USUARIOS: 'usuarios',
    CONFIGURACOES: 'configuracoes',
};
export const RECURSOS = [
    'empresa',
    'secretaria',
    'setor',
    'funcionario',
    'biometria',
    'dispositivo',
    'escala',
    'geofence',
    'ponto',
    'relatorio',
];
export const ACOES = [
    'criar',
    'ler',
    'atualizar',
    'excluir',
    'aprovar',
    'exportar',
];
export const NotificacaoCanal = {
    EMAIL: 'email',
    WHATSAPP: 'whatsapp',
};
export const NOTIFICACAO_CANAIS = ['email', 'whatsapp'];
export const NotificacaoStatus = {
    PENDENTE: 'pendente',
    ENVIADO: 'enviado',
    FALHA: 'falha',
    DESLIGADO: 'desligado',
};
export const NOTIFICACAO_STATUSES = [
    'pendente',
    'enviado',
    'falha',
    'desligado',
];
export const DiaSemana = {
    SEG: 'SEG',
    TER: 'TER',
    QUA: 'QUA',
    QUI: 'QUI',
    SEX: 'SEX',
    SAB: 'SAB',
    DOM: 'DOM',
};
export const DIAS_SEMANA = ['SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SAB', 'DOM'];
//# sourceMappingURL=enums.js.map